$("#callbackBtn").click(function (e) {
    e.preventDefault();
    let callbackNumber = $('#callback_number');

    let selectedCountryAbbr = callbackNumber.intlTelInput("getSelectedCountryData").iso2;
    requestContact.intlTelInput("setCountry", selectedCountryAbbr);

    $('#requestCallBack').modal('show');
    $('#request-name').val($('#callback_name').val());
    $('#requestContact').val(callbackNumber.val());
});

$(document).ready(function () {
    if (window.location.href.indexOf('?callback') !== -1) $('#requestCallBack').modal('show');
});

window.dashboardApiAxios = axios.create({
    baseURL: APP_BASE_URL,
});

$('#requestCallbackBtnSubmit').click(function () {
    var el = $(this);
    showErrorMsg('');
    callbackSubmitClickAnalytics();
    $('#requestCallBack #successMsg').hide();
    let name = $('#requestCallBack #request-name').val();
    if (name === '') {
        showErrorMsg('Please enter your name');
        el.prop('disabled', false);
        return false;
    }
    let requestContact = $('#requestContact');
    let number = requestContact.val();
    let selectedCountryAbbr = requestContact.intlTelInput("getSelectedCountryData").iso2;

    let verifyNumberFromScript = verifyPhoneNumberFromGoogleScript(number, selectedCountryAbbr);

    if(verifyNumberFromScript === false){
        showErrorMsg('Please enter correct contact number');
        el.prop('disabled', false);
        return false;
    }

    let countryCode = requestContact.intlTelInput("getSelectedCountryData").dialCode;
    if (countryCode.length >= 5 || countryCode.length === 0) {
        showErrorMsg('Please enter correct country code ');
        el.prop('disabled', false);
        return false;
    }

    let phone = countryCode === '91' ? number : countryCode + "-" + number;
    let schoolTypeRequest = $('#schoolTypeRequest').val();
    let message = $('#requestMessage').val();
    let role = 1;
    $('#requestCallbackBtnSubmit').prop("disabled", true);

    const leadData = {
        name: name,
        country_code: countryCode,
        identifier: phone,
        school_type: schoolTypeRequest,
        role: role,
        msg: message,
        notification: 1
    }
    leadData.provider = 'uae-callback';

    RequestFormNewUserCreation(leadData);
});


const callbackNumber = $('#callback_number');
const requestContact = $('#requestContact');
$(function(){

    callbackNumber.intlTelInput(defaultIntlTelInput);
    requestContact.intlTelInput(defaultIntlTelInput);

});


window.RequestFormNewUserCreation = (leadData) => {

    if(Object.keys.length === 0) return false;

    mainApiAxios.post('/create-enquire-lead', leadData).then(function (res) {

        $('#successMsg').removeClass('d-none').show();
        $('#requestCallBack form').trigger("reset");
        requestCallbackSuccessSubmittedAnalytics();
        setTimeout(function () {
            $('#requestCallBack #successMsg').addClass('d-none').hide();
            $('#requestCallBack').modal('hide');
        }, 3000);

    }).catch(err => {
        showErrorMsg('Something went wrong !! Try Again');
        $('#requestCallbackBtnSubmit').prop("disabled", false);
    });
}

window.showErrorMsg = (string) => {
    $('#requestCallBack #errorMsg').removeClass('d-none').text('').text(string)
}

window.requestCallbackSuccessSubmittedAnalytics = () => {
    ga('send', 'event', {
        eventCategory: 'Request Callback',
        eventAction: 'Request callback form successfully submitted',
        eventLabel: 'Request callback form successfully submitted'
    });
}

function callbackSubmitClickAnalytics() {
    ga('send', 'event', {
        eventCategory: 'Request Callback',
        eventAction: 'Request callback form submit button clicked',
        eventLabel: 'Request callback form submit button clicked'
    });
}
